var React = require('react');

function SharefacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M7.5 8.25V5.25C7.5 4.85218 7.65803 4.47064 7.93934 4.18934C8.22064 3.90804 8.60217 3.75 9 3.75H10.5V3.81604e-08H7.5C6.90903 -7.69261e-05 6.32383 0.116266 5.77783 0.342385C5.23183 0.568504 4.73573 0.899969 4.31785 1.31785C3.89997 1.73573 3.5685 2.23183 3.34238 2.77783C3.11627 3.32383 2.99992 3.90903 3 4.5V8.25H0V12H3V24H7.5V12H10.5L12 8.25H7.5Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",{"width":"12","height":"24","fill":"white"})))]);
}

SharefacebookInline.defaultProps = {"width":"12","height":"24","viewBox":"0 0 12 24","fill":"none"};

module.exports = SharefacebookInline;

SharefacebookInline.default = SharefacebookInline;
